module.exports = __webpack_public_path__ + "static/media/cubes-five-gold.24ff2057.png";